import * as Yup from 'yup'

const codNotaFinal = "^[0-9]([0-9])?(\,[0-9]{0,2})?$"

export const validationSchema = Yup.object().shape({
    id_curso_escolar: Yup.string().required('El curso escolar es obligatorio'),
    id_curso_colegio: Yup.string().required('El curso es obligatorio'),
    id_colegio:       Yup.string().required('El colegio es obligatorio'),
    nota_final:       Yup.string().matches(codNotaFinal, {message: 'El formato de la nota  final no es correcto', excludeEmptyString: true})
})